import React from "react";
import { Box, Button, Grid, makeStyles, TextField } from "@material-ui/core";
import apiHelper from "../../../../util/ApiHelper";
import { Close } from "@material-ui/icons";
import { Controller, useFieldArray } from "react-hook-form";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import SlideImage from "./SlideImage";

const slidesDefaultValue = {
  localizations: {
    en: { title: "", url: "", buttonText: "", image: "" },
    tc: { title: "", url: "", buttonText: "", image: "" },
  },
};

const useStyles = makeStyles((theme) => ({
  slidesBlk: {
    background: "#FFFFFF",
  },
  slidesBlkHeader: {
    background: "#EDEEF0",
    borderLeft: "3px solid #30659D",
    fontWeight: "bold",
    fontSize: "14px",
    lineHeight: "16px",
    padding: "12px 13px",
  },
  slidesBlkBody: {
    border: "1px solid #CCCCCC",
    borderTop: "0px",
    padding: "20px 13px",
  },
  deleteBtn: {
    margin: "0",
    padding: "0",
    minWidth: "initial",
  },
}));

export default function SlideSections({ disabled, ...props }) {
  const { defaultValues, control, lang, setValue, getValues } = props;
  const classes = useStyles();
  const { fields, append, remove, } = useFieldArray(
    {
      control, // control props comes from useForm (optional: if you are using FormContext)
      name: "slides", // unique name for your Field Array
      // keyName: "id", default to "id", you can change the key name
    }
  );

  const handleTitleChange = (index, e) => {
    setValue(`slides.${index}.localizations.${lang()}.title`, e.target.value);
  };

  const handleUrlChange = (index, e) => {
    setValue(`slides.${index}.localizations.${lang()}.url`, e.target.value);
  };

  const handleBtnTextChange = (index, e) => {
    setValue(
      `slides.${index}.localizations.${lang()}.buttonText`,
      e.target.value
    );
  };

  const handleFileUpload = (index, e) => {
    apiHelper.hknt
      .hkntUploadFile(e.target.files[0])
      .then((response) => {
        setValue(
          `slides.${index}.localizations.${lang()}.image`,
          response.data.url
        );
      })
      .catch((error) => console.log(error));
  };

  return (
    <>
      {fields.map((data, index) => (
        <div className={classes.slidesBlk} key={data.id}>
          <Grid
            container
            className={classes.slidesBlkHeader}
            xs={12}
            alignItems="center"
            justify="space-between"
          >
            <span>Slide {index + 1}</span>
            {disabled || (
              <Button
                className={classes.deleteBtn}
                onClick={() => remove(index)}
              >
                <Close style={{ fontSize: "14px", lineHeight: "16px" }} />
              </Button>
            )}
          </Grid>
          <Box className={classes.slidesBlkBody}>
            <Grid container spacing={3} direction="column">
              <Grid container item xs={12}>
                <Grid
                  container
                  item
                  xs={12}
                  style={lang() === "tc" ? { display: "none" } : {}}
                >
                  <Controller
                    name={`slides.${index}.localizations.en.title`}
                    control={control}
                    defaultValue={defaultValues[index] ? defaultValues[index].localizations.en.title : ''}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Title of Highlight Programme"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        onChange={(e) => handleTitleChange(index, e)}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  style={lang() === "en" ? { display: "none" } : {}}
                >
                  <Controller
                    name={`slides.${index}.localizations.tc.title`}
                    control={control}
                    defaultValue={defaultValues[index] ? defaultValues[index].localizations.tc.title : ''}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Title of Highlight Programme"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        onChange={(e) => handleTitleChange(index, e)}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={12}>
                <Grid
                  container
                  item
                  xs={6}
                  style={lang() === "tc" ? { display: "none" } : {}}
                >
                  <Controller
                    name={`slides.${index}.localizations.en.url`}
                    control={control}
                    defaultValue={defaultValues[index] ? defaultValues[index].localizations.en.url : ''}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Programme Url"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        onChange={(e) => handleUrlChange(index, e)}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid
                  container
                  item
                  xs={6}
                  style={lang() === "en" ? { display: "none" } : {}}
                >
                  <Controller
                    name={`slides.${index}.localizations.tc.url`}
                    control={control}
                    defaultValue={defaultValues[index] ? defaultValues[index].localizations.tc.url : ''}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Programme Url"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        onChange={(e) => handleUrlChange(index, e)}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>

                <Grid
                  container
                  item
                  xs={6}
                  style={lang() === "tc" ? { display: "none" } : {}}
                >
                  <Controller
                    name={`slides.${index}.localizations.en.buttonText`}
                    control={control}
                    defaultValue={defaultValues[index] ? defaultValues[index].localizations.en.buttonText : ''}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Button Text"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        onChange={(e) => handleBtnTextChange(index, e)}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid
                  container
                  item
                  xs={6}
                  style={lang() === "en" ? { display: "none" } : {}}
                >
                  <Controller
                    name={`slides.${index}.localizations.tc.buttonText`}
                    control={control}
                    defaultValue={defaultValues[index] ? defaultValues[index].localizations.tc.buttonText : ''}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Button Text"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        onChange={(e) => handleBtnTextChange(index, e)}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
              </Grid>

              <SlideImage
                defaultValues={defaultValues}
                setValue={setValue}
                getValues={getValues}
                classes={classes}
                control={control}
                index={index}
                handleFileUpload={handleFileUpload}
                lang={() => lang()}
                Controller={Controller}
                disabled={disabled}
              />
            </Grid>
          </Box>
        </div>
      ))}
      {disabled || (
        <Button
          onClick={() => {
            append(slidesDefaultValue);
          }}
          style={{
            color: "#306F9D",
            margin: "5px 0",
          }}
        >
          <AddCircleIcon />
          Add Slide
        </Button>
      )}
    </>
  );
}
